import { ErrorMsg } from "./style";

export const Error = ({ msg }) => {
  return <ErrorMsg> {msg}</ErrorMsg>;
};
